import { TimePickerInput } from "@impero-com/common/components/form/fields/timePickerInput/timePickerInput";
import { TimezoneKey } from "@impero-com/common/utils/timezone";
import { Control, useController } from "react-hook-form";

import { TimezoneTypeaheadPopupInput } from "components/form/fields/timezoneTypeaheadPopupInput";

import { ControlViewFormSchema } from "../formSchema";

import * as theme from "./TimeAndTimezone.theme.css";

export interface TimeAndTimezoneProps {
    control: Control<ControlViewFormSchema>;
    disabled?: boolean;
}

export const TimeAndTimezone = ({
    control,
    disabled,
}: TimeAndTimezoneProps) => {
    return (
        <div className={theme.timeAndTimezone}>
            <RHFTimePickerInput control={control} disabled={disabled} />
            <RHFTimezoneInput control={control} disabled={disabled} />
        </div>
    );
};

function RHFTimePickerInput({
    control,
    disabled,
}: {
    control: Control<ControlViewFormSchema>;
    disabled?: boolean;
}) {
    // Disable the input, NOT the controller: RHF drops disabled fields from the
    // payload, and this field is shared, so that would delete dueTime on submit.
    const { field, fieldState } = useController({
        control,
        name: "scheduling.dueTime",
    });

    return (
        <TimePickerInput
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            fieldRef={field.ref}
            error={fieldState.error?.message}
            disabled={disabled}
            format="HH:mm"
        />
    );
}

function RHFTimezoneInput({
    control,
    disabled,
}: {
    control: Control<ControlViewFormSchema>;
    disabled?: boolean;
}) {
    const { field, fieldState } = useController({
        control,
        name: "scheduling.timezoneName",
    });

    return (
        <TimezoneTypeaheadPopupInput
            value={field.value as TimezoneKey}
            onChange={field.onChange}
            onBlur={field.onBlur}
            fieldRef={field.ref}
            error={fieldState.error?.message}
            disabled={disabled}
        />
    );
}
